import { useQueries } from "react-query";
import { AxiosAreasAPI } from "../areas/Api";
import { AxiosEmployeeAPI } from "./Api";
import { AxiosPositionsAPI } from "../positions/Api";
import { AxiosCorporationsApi } from "../common/Api";

const EMPLOYEE = 0;
const AREAS = 1;
const POSITIONS = 2;
const CORPORATION = 3;
const CONTRACT_TYPES = 4;

export const useFetchEmployeeFormData = searchState => {
  const combineResults = results => {
    return {
      data: {
        employees: results[EMPLOYEE].data,
        areas: results[AREAS].data,
        positions: results[POSITIONS].data,
        corporation: results[CORPORATION].data,
        contractTypes: results[CONTRACT_TYPES].data
      },
      isFetching: results.some(result => result.isFetching),
      isLoading: results.some(result => result.isLoading),
      isPending: results.some(result => result.isPending),
      isError: results.some(result => result.isError),
      errors: results.map(result => result.error)
    };
  };

  const queriesResults = useQueries([
    {
      queryKey: ["employees", searchState.managerSearch],
      queryFn: () =>
        AxiosEmployeeAPI.getAllAccessible({ search: searchState.managerSearch }, {}),
      refetchOnWindowFocus: false,
      keepPreviousData: true
    },
    {
      queryKey: ["areas", searchState.areaSearch],
      queryFn: () =>
        AxiosAreasAPI.getAll(
          { search: searchState.areaSearch },
          { expand: "_extra" }
        ),
      refetchOnWindowFocus: false,
      keepPreviousData: true
    },

    {
      queryKey: ["positions", searchState.positionSearch],
      queryFn: () =>
        AxiosPositionsAPI.getAll({ search: searchState.positionSearch }, {}),
      refetchOnWindowFocus: false,
      keepPreviousData: true
    },
    {
      queryKey: ["corporation", searchState.corporationSearch],
      queryFn: () =>
        AxiosCorporationsApi.getAll(
          {
            search: searchState.corporationSearch,
            expand: ["branchs_corporation"]
          },
          {}
        ),
      refetchOnWindowFocus: false,
      keepPreviousData: true
    },
    {
      queryKey: ["contract_types"],
      queryFn: () => AxiosEmployeeAPI.getContractTypes({}),
      refetchOnWindowFocus: false,
      keepPreviousData: true
    }
  ]);

  return { ...combineResults(queriesResults) };
};
